export default function validatePassword(value, config = {}) {
  const defaultConfig = {
    upper: true,
    lower: true,
    number: true,
    special: true,
    min: 8,
    max: null
  }

  const rules = Object.assign({}, defaultConfig, config)

  const rulesExp = []

  rules.upper && rulesExp.push('(?=.*[A-Z])')

  rules.lower && rulesExp.push('(?=.*[a-z])')

  rules.number && rulesExp.push('(?=.*[0-9])')

  rules.special && rulesExp.push('(?=.*[!@#$%&*()_+=\\-\'"])')

  const exp = `^${rulesExp.join('')}.{${rules.min},${rules.max || ''}}$`

  return (new RegExp(exp)).test(value)
}
